import yup, { stringRequired, phoneNumber } from "common/libs/yup";

export const developerFeatureRequestSchema = yup.object({
  companyName: stringRequired,
  companyPhone: phoneNumber.required(),
});

export type DeveloperFeatureRequestSchema = yup.InferType<typeof developerFeatureRequestSchema>;
